<template>
	<div>
		<div class="popBoxBg" v-show="show"></div>
		<div class="popBox" v-show="show">
			<div class="inner">
				
				<div class="img">
					<img src="../../assets/exchange.png" >
				</div>
				<h3>
					正在进行医保交易
				</h3>
				<p>请稍后...</p>
				
				<div class="progress-bar">
					<div class="progress" :style="{'width': percentage +  '%'}"></div>
				</div>
				<div class="fcc">
					<div class="button-blue" @click="close">
						确定
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'q-pop-yibao',
		// props: {
		// 	msg: String
		// },
		data() {
			return {
				timer:null,
				show:true,
				percentage:0
			}
		},
	
		
		mounted() {
			var that = this;
			that.timer = setInterval(function() {
				that.percentage++
				if (that.percentage > 100) {
					that.percentage=0
				}
			}, 50 )
		},
		methods: {
			close(){
				this.$emit("click-enter",false)
			}
		},
		beforeDestroy() {
			clearInterval(this.timer);
		}
		
	}
</script>

<style scoped lang="less">
	.progress-bar{
		
		height: 41px;
		background: #ECECEC;
		border-radius: 14px;
		position: relative;
		overflow: hidden;
		margin-bottom: 117px;
		.progress{
			width: 229px;
			height: 41px;
			background: #3399FF;
			border-radius: 14px;
		}
	}
		.inner{
			padding: 78px 90px 0;
			text-align: center;
			img{
				width: 282px;
				height: 282px;display: block;
				margin: 0 auto;
				
			}
			h3{
								
				font-size: 56px;color: #000;
				line-height: 60px;
				padding: 40px 0 30px;

			}
			p{
				font-size: 38px;
				color: #828282;
				line-height: 40px;
				margin-bottom: 43px;
			}
			li{
				width: 370px;
				height: 251px;
				padding-top: 31px;
				-webkit-box-sizing: border-box;
				-moz-box-sizing: border-box;
				box-sizing: border-box;
				margin: 0 auto;
				border-radius: 10px;
				margin-bottom: 40px;
				cursor: pointer;
				&.on{
					background: #01A0A0;
					p{
						color: #fff;
					}
				}
			}
			
		}
		
		.el-progress{
			margin-bottom: 117px;
		}
</style>
